module.exports = __webpack_public_path__ + "static/media/RFID.f5e2dea7.gif";